<h2 mat-dialog-title>Student Notes</h2>
<mat-dialog-content>
  <div style="width:500px; padding: 10px 20px;">
      <ul>
          <li *ngFor="let note of notes" [ngStyle]="{'font-weight': note.DisplayBold ? 'bold': 'normal'}">
              {{note.Note}}
          </li> 
      </ul>
  </div>
  
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>